import { render, staticRenderFns } from "./informacoes.vue?vue&type=template&id=a8b88b80&scoped=true"
import script from "./informacoes.vue?vue&type=script&lang=js"
export * from "./informacoes.vue?vue&type=script&lang=js"
import style0 from "./informacoes.vue?vue&type=style&index=0&id=a8b88b80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b88b80",
  null
  
)

export default component.exports